// TODO: This duplicates destinationSelectorStore.ts from TripOverview and should be refactored https://trello.com/c/4wELjdBw

import { defineStore } from 'pinia';
import { ref } from 'vue';

import { HotelIngredient } from '@apps/main/modules/recipe/ingredients';
import { injectStrict } from '@apps/main/modules/helpers/injectStrict';
import { RecipeStateKey } from '@apps/main/modules/state/state';

import { CategoryType } from '@libs/trip-planner-interfaces';
import type {
  AutoCompleteSuggestion,
  IngredientId,
} from '@libs/trip-planner-interfaces';

export const useHotelSelectionDestinationSelectorStore = defineStore(
  'HotelSelectionDestinationSelectorStore',
  () => {
    const recipeState = injectStrict(RecipeStateKey);

    // State
    const searchText = ref<string>('');
    const editingIngredientId = ref<IngredientId | undefined>(undefined);

    // Actions
    function setDestinationSelectorData(
      newSearchText: string,
      ingredientId: IngredientId | undefined
    ): void {
      searchText.value = newSearchText;
      editingIngredientId.value = ingredientId;
    }

    function handleConfirmSelection(
      newDestination: AutoCompleteSuggestion
    ): void {
      if (editingIngredientId.value) {
        updateDestination(newDestination, editingIngredientId.value);
      } else {
        addNewDestination(newDestination);
      }
      clearDestinationSelectorData();
    }

    function clearDestinationSelectorData(): void {
      searchText.value = '';
      editingIngredientId.value = undefined;
    }

    function updateDestination(
      newDestination: AutoCompleteSuggestion,
      ingredientId: IngredientId
    ): void {
      const isHotelAutoCompleteSuggestion =
        newDestination.categoryType === CategoryType.Hotel;

      recipeState.updateHotelIngredientById(
        ingredientId,
        newDestination.label,
        newDestination.categoryType,
        {
          skipItinerarySearch: isHotelAutoCompleteSuggestion,
          forceItineraryLoad: isHotelAutoCompleteSuggestion,
        }
      );
    }

    function addNewDestination(newDestination: AutoCompleteSuggestion): void {
      const isHotelAutoCompleteSuggestion =
        newDestination.categoryType === CategoryType.Hotel;

      const newHotelIngredient = new HotelIngredient(true);
      newHotelIngredient.setSearchText(
        newDestination.label,
        newDestination.categoryType
      );

      recipeState.addIngredient(newHotelIngredient, {
        skipItinerarySearch: isHotelAutoCompleteSuggestion,
        forceItineraryLoad: isHotelAutoCompleteSuggestion,
      });
    }

    return {
      // State
      searchText,

      // Actions
      clearDestinationSelectorData,
      handleConfirmSelection,
      setDestinationSelectorData,
    };
  }
);
